import type { DemoKey } from './keys';

export const nl: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometrie · 3D',
  'panel.figure': 'Figuur',
  'panel.dims': 'Afmetingen',
  'panel.style': 'Uiterlijk',
  'panel.lines': 'Speciale lijnen',
  'style.body': 'Lichaam',
  'style.line': 'Lijn',
  'style.cut': 'Doorsnede',
  'style.labels': 'Hoekpuntlabels',
  'group.face': 'Vlakdiagonalen / beschrijvenden',
  'group.space': 'Diagonalen / assen / medianen',
  'split.label': 'Doorsnede',
  'btn.animate': 'Animeer',
  'btn.reset': 'Reset',
  'hint.line1': 'Sleep om te draaien · Scroll om te zoomen',
  'hint.line2': 'Klik op een lijn om te selecteren',
  'fig.cuboid': 'Balk',
  'fig.cube': 'Kubus',
  'fig.triPrism': 'Driehoekig prisma',
  'fig.hexPrism': 'Zeshoekig prisma',
  'fig.tetrahedron': 'Tetraëder',
  'fig.squarePyramid': 'Vierkante piramide',
  'fig.cylinder': 'Cilinder',
  'fig.cone': 'Kegel',
  'fig.sphere': 'Bol',
  'fig.frustumPyramid': 'Afgeknotte piramide',
  'fig.frustumCone': 'Afgeknotte kegel',
  'dim.length': 'lengte',
  'dim.width': 'breedte',
  'dim.height': 'hoogte',
  'dim.side': 'zijde',
  'dim.radius': 'straal',
  'dim.r1': 'onderstraal',
  'dim.r2': 'bovenstraal',
  'dim.sideBase': 'basiszijde',
  'dim.sideTop': 'topzijde',
  'info.face': 'vlak',
  'info.center': 'door midden',
  'info.diagonal': 'diagonaal',
  'info.axial': 'asdiagonaal',
  'info.diameter': 'diameter',
  'info.generator': 'beschrijvende',
  'info.axis': 'as',
  'info.height': 'hoogte',
  'info.median': 'mediaan',
  'info.apothem': 'apothema',
  'info.diameterBase': 'basisdiameter',
  'info.diameterTop': 'topdiameter',
};
